import React, { useEffect, useRef, useState } from 'react';

import { Box } from '@/box';
import { getEnvironmentKey } from '@/env/client/config';

import { getDisloyaltyBaseUrl } from '../utils';

interface MembershipConfirmationCardProps {
  amountSaved: number;
  currency?: string;
  email?: string;
  firstName?: string;
  lastName?: string;
  membershipPrice: number;
  paymentMethod: string;
  language: string;
}

export const MembershipConfirmationCard = ({
  amountSaved,
  currency,
  email,
  firstName,
  lastName,
  membershipPrice,
  paymentMethod,
  language,
}: MembershipConfirmationCardProps) => {
  const ref = useRef<HTMLIFrameElement>(null);

  const [cardHeight, setCardHeight] = useState(600);

  useEffect(() => {
    function handleMessage(event: MessageEvent) {
      if (event.data?.type === 'RESIZE_TELEPORT_BANNER' && ref.current) {
        setCardHeight(event.data.height);
      }
    }
    window.addEventListener('message', handleMessage);
    return () => window.removeEventListener('message', handleMessage);
  }, []);

  const env = getEnvironmentKey();

  const disloyaltyConfirmationUrl = `${getDisloyaltyBaseUrl(
    env
  )}/${language}/teleport/confirmation/?amountSaved=${amountSaved}&currency=${currency}&email=${encodeURIComponent(
    email ?? ''
  )}&firstName=${firstName}&lastName=${lastName}&membershipPrice=${membershipPrice}&paymentMethod=${paymentMethod}`;

  return (
    <Box
      width="100%"
      css={{
        border: '1px solid #143C21',
        borderRadius: '8px',
        overflow: 'hidden',
        marginBottom: '40px',
      }}
    >
      <iframe
        ref={ref}
        src={disloyaltyConfirmationUrl}
        css={{
          overflow: 'hidden',
          height: Math.ceil(cardHeight),
          width: '100%',
          transition: 'height 0.2s',
        }}
      />
    </Box>
  );
};
